import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('CNotificationsFromStore'),_c('NavBar'),_c(VMain,{staticStyle:{"background-color":"#F5F6F8"}},[_c(VContainer,[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }